//module common {
export enum ActionType { Delete, Edit, Insert, Save, CopyFrom, Custom }
export enum BladeSlide { left, right }
export enum GridColumnDirection { none, ASC, DESC }
export enum GridAutoLoad { Never, Always, OnlyOneRecord }
export enum RecordUpdateAction { None, Insert, Update, Delete }
export enum EntityStyle { Classic, Blade }
export enum FormType { SelectList, Search }
export enum GridType { UIGrid, Dashboard, Inline }
export enum FieldType { String, Int, Bool, DateTime, Enum, Password, Float, Text, YesNo, Byte, Time, File, Guid, Button, Grid }
export enum DataObjectType { JsonString, Json, String }
export enum DataSourceStatus { Pending, Started, Success, Failed }
export enum MessageButtonType { Ok, Cancel, Close, Yes, No }
export enum ViewType {
  String, Dropdown, Text, CheckBox, IntNoFormat, DateFrequency, InputMask, Int, Slider, MultiSelect, Time, Pictures, TimeEstimate, Document, ContainerLayoutConfig, QRScanner, Date, Float, Switch, DateTime, RadioButton,
  AutoComplete, File, Signature, Password, CustomControl, YesNo, InputGroupString, Link, Currency, DateRange, YesNoIcon, Thumbnail, StatusChange
}
export enum WorkflowType {
  WorkflowRequisitionCreated,
  WorkflowApproved,
  WorkflowProcurementOfficer,
  WorkflowApprovalRequested,

  WorkflowItemApproved,
  WorkflowItemDeclined,
  WorkflowItemPending,
  WorkflowItemApprovalRequested,

  WorkflowPartialPurchaseOrderDispatched,
  WorkflowPartialIssuedToWarehouse,
  WorkflowPartialPending,
  WorkflowItemPermanentDeclined,
  WorkflowCancelled,
  WorkflowProcessing,
  WorkflowItemProcessed,
  WorkflowProcessed,
  WorkflowContractManagerApprovalRequested,
  WorkflowRejectedForCorrection,
  WorkflowPartialComplete,
  WorkflowRejectedForCorrectionOfficer,
  WorkflowItemRejectedForCorrectionOfficer,
  WorkflowCompleted, WorkflowGRND,
  WorkflowItemGRND,
  WorkflowItemPOGenerated,
  WorkflowItemComplete,
  WorkflowPartialItemGRND,
  WorkflowPartialItemPOGenerated,
  WorkflowIssuedToWarehouse,

  WorkflowProcurementAdminApprovalRequired
}


export enum WhereExpressionType {
  Contains = 1,
  Equals =2,
  GreaterThanOrEqual =3,
  LessThanOrEqual =4,
  DateRange = 5
}
